import { useEffect } from "react";
import { trackEvent } from "./trackingService";

export default function AppInstallTracker() {
    useEffect(() => {
        //do tracking only once when pwa is installed (working in Chrome only)
        //triggers right after the pwa installation process is completed
        const trackAndroidPWAInstallation = () => {
            trackEvent({
                category: "PWA android",
                name: "[PWA android] - Téléchargement réussi",
                action: "Télécharger"
            });
        };
        window.addEventListener("appinstalled", trackAndroidPWAInstallation);
        //For Safari iOS the approach is different - user needs to open the application from the pwa icon
        //It is in standalone mode, so on first load we do tracking and set a flag in the localStorage to prevent next tracking
        if ((window.navigator as any).standalone) {
            // Check if the installation flag is already set
            if (!localStorage.getItem("pwaInstalled")) {
                // PWA installation detected
                // Send installation data to matomo
                //setTimeout is used because on iOS window._paq is possibly not initialized at this moment
                setTimeout(() => {
                    trackEvent({
                        category: "PWA ios",
                        name: "[PWA ios] - Ouverture réussie",
                        action: "Télécharger"
                    });
                }, 2000);
                // Set the installation flag in localStorage
                localStorage.setItem("pwaInstalled", "true");
            }
        }
        return () => {
            window.removeEventListener("appinstalled", trackAndroidPWAInstallation);
        };
    }, []);
    return null;
}
